import React from "react";
import {
  Table,
  TableRow,
  TableHead,
  TableBody,
  TableCell
} from "@material-ui/core";
import useStyles from "../styles";
import { Delete } from "@material-ui/icons";

export default function FingerPrintTable({ data, onDelete, onDeleteAll }) {
  const classes = useStyles();

  if (data == null || !!(data)) {
  } else {
    var keys = Object.keys(data[0]).map(i => i.toUpperCase());
    keys.shift();
  }

  return (
    <>
      <Table className="mb-0">
        <TableHead>
          <TableRow className={classes.root} >
            <TableCell size='small' >NOMBRE</TableCell>
            <TableCell size='small' padding='none' style={{ textAlign: "center" }}>FECHA DE CREACIÓN</TableCell>
            <TableCell size='small' padding='none' ></TableCell>
            {/*{keys.map(key => (
              <TableCell key={key}>{key}</TableCell>
            ))}*/}
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map(({ id, name, date }) => (
            <TableRow key={id}>
              <TableCell size='small' className={classes.tableTextStyle} >{name}</TableCell>
              <TableCell size='small' padding='none' className={classes.tableCenterTextStyle} >{date}</TableCell>
              <TableCell size='small' className={classes.tableTextStyle} >
                <div>
                  <div className={classes.divActionButton}>
                    <Delete className={classes.iconAcctionInventory}
                      onClick={onDelete(id)}
                    />
                  </div>
                </div>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>

      <div className={classes.footerTable}>
        <div className={classes.footerTableSecondDiv}>
          <p onClick={onDeleteAll} className={data.length > 0 ? classes.deleteText : classes.deleteTextDisable }>BORRAR TODO</p>
        </div>
      </div>
    </>
  );
}
